import moment from "moment";
import { createCrudActions } from '../utils/crudGenerator';
import { axios } from "../connection/ConnectionHandler";
import { SHOW_NOTIFICATION } from "../constants";
import { fetchZones } from "./zonesActions";

const formatIngredients = (data) => {
    if (!data) {
        return [];
    }
    const formatItem = (item) => ({
        ...item,
        label: `${item.name}`,
        value: item._id,
        expirationDate: item.expirationDate && moment(item.expirationDate),
    });

    if (Array.isArray(data)) {
        return data.map(formatItem);
    }
    return formatItem(data);
};

export const {
    fetch: fetchIngredients,
    create: createIngredient,
    update: updateIngredient,
    delete: deleteIngredients
} = createCrudActions('INGREDIENT', "Ingrediente", formatIngredients);

export const toggleIngredientStock = (id, withPurchase = true) => async (dispatch) => {
    try {
        const response = await axios.put(`ingredient/${id}/toggle-stock`, { withPurchase });
        const formattedData = formatIngredients(response.data);
        dispatch({ type: "UPDATE_INGREDIENT", payload: formattedData });
        return formattedData;
    } catch (err) {
        dispatch({
            type: SHOW_NOTIFICATION,
            payload: {
                show: true,
                status: "error",
                message: "Error al actualizar el stock.",
            },
        });
        return null;
    }
};

export const importIngredientsWithAI = (text) => async (dispatch) => {
    try {
        dispatch({
            type: SHOW_NOTIFICATION,
            payload: {
                show: true,
                status: "info",
                message: "Procesando ingredientes con IA...",
            },
        });

        const response = await axios.post("/ai/import-ingredients", { text });
        const {
            createdIngredientsCount = 0,
            existingIngredientsCount = 0,
            createdZonesCount = 0,
        } = response.data || {};

        dispatch({
            type: SHOW_NOTIFICATION,
            payload: {
                show: true,
                status: "success",
                message: `IA completada: ${createdIngredientsCount} ingredientes nuevos, ${existingIngredientsCount} ya existentes, ${createdZonesCount} zonas nuevas.`,
            },
        });

        await dispatch(fetchIngredients());
        await dispatch(fetchZones());
        return true;
    } catch (err) {
        dispatch({
            type: SHOW_NOTIFICATION,
            payload: {
                show: true,
                status: "error",
                message: "No se pudo importar ingredientes con IA.",
            },
        });
        return false;
    }
};
